import React from 'react'

function Services() {
    return (
        <>
            <section class="section-hero overlay inner-page bg-image"  id="home-section">
                <div class="container">
                    <div class="row">
                        <div class="col-md-7">
                            <h1 class="text-white font-weight-bold">Services</h1>
                            <div class="custom-breadcrumbs">
                                <a href="#">Home</a> <span class="mx-2 slash">/</span>
                                <span class="text-white"><strong>Services</strong></span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="site-section services-section bg-light block__62849" id="next-section">
                <div class="container">

                    <div class="row">
                        <div class="col-6 col-md-6 col-lg-4 mb-4 mb-lg-5">

                            <a href="#" class="block__16443 text-center d-block">
                                <span class="custom-icon mx-auto"><span class="icon-magnet d-block"></span></span>
                                <h3>Graphic Design</h3>
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugit facilis, pariatur harum labore aperiam assumenda.</p>
                            </a>

                        </div>
                        <div class="col-6 col-md-6 col-lg-4 mb-4 mb-lg-5">

                            <a href="#" class="block__16443 text-center d-block">
                                <span class="custom-icon mx-auto"><span class="icon-trophy d-block"></span></span>
                                <h3>Marketing Strategy</h3>
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugit facilis, pariatur harum labore aperiam assumenda.</p>
                            </a>

                        </div>
                        <div class="col-6 col-md-6 col-lg-4 mb-4 mb-lg-5">

                            <a href="#" class="block__16443 text-center d-block">
                                <span class="custom-icon mx-auto"><span class="icon-laptop d-block"></span></span>
                                <h3>Web Design</h3>
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugit facilis, pariatur harum labore aperiam assumenda.</p>
                            </a>

                        </div>
                        <div class="col-6 col-md-6 col-lg-4 mb-4 mb-lg-5">

                            <a href="#" class="block__16443 text-center d-block">
                                <span class="custom-icon mx-auto"><span class="icon-search d-block"></span></span>
                                <h3>SEO</h3>
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugit facilis, pariatur harum labore aperiam assumenda.</p>
                            </a>

                        </div>
                        <div class="col-6 col-md-6 col-lg-4 mb-4 mb-lg-5">

                            <a href="#" class="block__16443 text-center d-block">
                                <span class="custom-icon mx-auto"><span class="icon-paper-plane d-block"></span></span>
                                <h3>Market Leading </h3>
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugit facilis, pariatur harum labore aperiam assumenda.</p>
                            </a>

                        </div>
                        <div class="col-6 col-md-6 col-lg-4 mb-4 mb-lg-5">

                            <a href="#" class="block__16443 text-center d-block">
                                <span class="custom-icon mx-auto"><span class="icon-plug d-block"></span></span>
                                <h3>Pixel Perfect Design</h3>
                                <p class="d-sm-block">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugit facilis, pariatur harum labore aperiam assumenda.</p>
                            </a>

                        </div>
                    </div>


                </div>
            </section>
        </>
    )
}

export default Services
